module.exports = require("@wildboar/x500/src/lib/distributed/IPV4_AFI_IDI");